import moengageSdk from '@moengage/web-sdk';

import type { MoengageScreenName } from './moengage.screens';

let initialized = false;

const STORAGE_KEYS = {
  userUuid: 'moengage_user_uuid',
};

function init(appId: string, env: 'LIVE' | 'TEST' = 'LIVE', cluster?: string) {
  if (typeof window === 'undefined') return;
  if (initialized) return;
  if (!appId) return;

  const assignedEnv = env === 'LIVE' ? moengageSdk.env.LIVE : moengageSdk.env.TEST;

  const normalizedCluster =
    typeof cluster === 'string' && cluster.trim().length > 0 ? cluster.trim() : 'DC_4';

  moengageSdk.initialize({
    app_id: appId,
    env: assignedEnv,
    cluster: normalizedCluster,
    logLevel: 0,
  } as any);

  initialized = true;
}

function getSessionToken(): string | null {
  return document.querySelector('meta[name="api-session-token"]')?.getAttribute('content') ?? null;
}

function isLoggedIn(): boolean {
  return !!getSessionToken();
}

function getStoredUserUuid(): string | null {
  return localStorage.getItem(STORAGE_KEYS.userUuid);
}

function enableTracking(userUuid: string) {
  if (typeof window === 'undefined') return;
  if (!userUuid) return;

  localStorage.setItem(STORAGE_KEYS.userUuid, userUuid);

  if (!initialized) {
    return;
  }

  if (!isLoggedIn()) {
    return;
  }

  moengageSdk.add_unique_user_id(userUuid);
}

function trackPageView(screenName: MoengageScreenName) {
  if (typeof window === 'undefined') return;
  if (!initialized) return;
  if (!isLoggedIn()) return;
  const userUuid = getStoredUserUuid();
  if (!userUuid) return;
  moengageSdk.add_unique_user_id(userUuid);

  moengageSdk.track_event('Page View', {
    'Page Title': screenName,
    URL: window.location.href,
  });
}

function disableTracking() {
  if (typeof window === 'undefined') return;

  localStorage.removeItem(STORAGE_KEYS.userUuid);

  moengageSdk.destroy_session?.();
}

if (typeof window !== 'undefined') {
  (window as any).MoEngageLogout = () => {
    disableTracking();
  };
}

export const moengage = {
  init,
  enableTracking,
  trackPageView,
};
